// @flow
import * as React from 'react';
import AutoCompleteAddressInput from './AutoCompleteAddressInput';
import Field from '../Field';

const AutoCompleteAddressField = ({
  name,
  inlineLabel,
  label,
  description,
  noWrap,
  customErrorMatch,
  ...props
}: {
  name: string,
  inlineLabel?: boolean,
  label?: string,
  description?: string,
  noWrap?: boolean,
  addressTypes: Array<string>,
  componentRestrictions?: Object,
  onUpdateValue?: string => void,
  onAutoCompleteSuggestionSelected: Object => void,
  customErrorMatch?: APIErrors => ?Object
}) => (
  <Field
    inputProps={props}
    name={name}
    description={description}
    inlineLabel={inlineLabel}
    label={label}
    noWrap={noWrap}
    customErrorMatch={customErrorMatch}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <AutoCompleteAddressInput
        id={id}
        name={name}
        value={value || ''}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={e => {
          const v = e.target.value;
          updateValue(v);
          if (props.onUpdateValue) {
            props.onUpdateValue(v);
          }
        }}
        {...props}
      />
    )}
  />
);

export default AutoCompleteAddressField;
